export function parseSlackMarkdownText(text: string): string {
  if (!text) return '';
  const textBuild = text
    // Escape HTML to prevent XSS injections
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

    // Handle combined Slack styles first so nested markers are not left raw.
    // Example: _~text~_ => <del><em>text</em></del>
    .replace(/_~([\s\S]*?)~_/g, '<del><em>$1</em></del>')
    .replace(/~_([\s\S]*?)_~/g, '<del><em>$1</em></del>')

    // Convert *Bold* to <strong>Bold</strong>
    .replace(/\*(.*?)\*/g, '<strong>$1</strong>')

    // Convert _Italic_ to <em>Italic</em>
    .replace(/_(.*?)_/g, '<em>$1</em>')

    // Convert ~Strikethrough~ to <del>Strikethrough</del>
    .replace(/~(.*?)~/g, '<del>$1</del>')

    // Convert `Inline Code` to <code>Inline Code</code>
    .replace(/`(.*?)`/g, '<code>$1</code>');

  return textBuild;
}
